import Axios from "../../configs/axios.config";

// export const getUserList = (data) => Axios.get('/user', { params: data }).then(response => response.data.data);
export const fetchProfileData = (data) => Axios.get(`/user/profile`);

// import Axios from "../../configs/axios.config";

export const getUserList = (data) => Axios.get('/user', { params: data }).then(response => response.data);
export const getUserDetail = (id,data) => Axios.get(`/user/${id}`,{ params: data }).then(response => response.data);
export const getUserDetailProfile = (id,data) => Axios.get(`/user/profile/${id}`,{ params: data }).then(response => response.data);



export const getWorkspaceAdminList = (data, config = {}) => Axios.get(`/user/workspace-admin`, data, config).then(response => response.data.data);
export const getWorkspaceAdminDetail = (id, config = {}) => Axios.get(`/user/workspace-admin/${id}`, config).then(response => response.data.data);
export const createWorkspaceAdmin = (data) => Axios.post(`/user/workspace-admin`, data).then(response => response);
export const updateWorkspaceAdmin = (data, id) => Axios.put(`/user/workspace-admin/${id}`, data).then(response => response.data.data);
export const changePassword = (data) => Axios.post(`/user/change-password`, data);
export const forgotPassword = (data) => Axios.post(`/auth/forgot-password`, data);
export const resetPassword = (data) => Axios.post(`/auth/reset-password`, data);
// export const closeUserOnboard = () => Axios.put(`/auth/user-onboard`);
// export const getWorkspaceList = (data) => Axios.get('/workspaces', { params: data }).then(response=>response.data.data);
export const userVerification = (data) => Axios.post(`/auth/user-verification`, data);
export const verifyVerificationOTP = (data) => Axios.post(`/auth/verify-verification-otp`, data);



export const createUser = (data) => Axios.post(`/user`, data);

export const updateUser = (data, id) => Axios.put(`/user/profile/${id}`, data);
export const deleteUser = (id) =>
    Axios.delete(`/user/${id}`);

// export const getUserAttendance = (data) => Axios.get(`/user/attendance`,data).then(response => response.data.data);

export const exportUser = (data) =>
  Axios.get(`/user/export`, { params: data });
export const userSample = (data) => Axios.get(`/user/sample`,{ params: data }).then(response => response);
export const getUserImportFormFields = (data) => Axios.get(`/user/import-validate`,{ params: data }).then(response => response.data.data);


export const createEducation = (data) => Axios.post(`/education`, data).then(response => response.data.data);
export const updateEducation = ( data, id) => Axios.put(`/education/${id}`, data);
// API returns: { message, education: { data: [...], meta: {...} } }
export const getEducationList = (data) =>
  Axios.get('/education', { params: data }).then(response => {
    const payload = response?.data || response;
    return payload?.education?.data || payload?.data || [];
  });
export const getEducationDetail = (id) => Axios.get(`/education/${id}`).then(response => response.data.data);
export const deleteEducation = (id) => Axios.delete(`/education/${id}`);


export const createExperience = (data) => Axios.post(`/experience`, data).then(response => response.data.data);
export const updateExperience = ( data, id) => Axios.put(`/experience/${id}`, data);
// API returns: { message, experience: { data: [...], meta: {...} } }
export const getExperienceList = (data) =>
  Axios.get('/experience', { params: data }).then(response => {
    const payload = response?.data || response;
    return payload?.experience?.data || payload?.data || [];
  });
export const getExperienceDetail = (id) => Axios.get(`/experience/${id}`).then(response => response.data.data);
export const deleteExperience = (id) => Axios.delete(`/experience/${id}`);

export const createDocument = (data) => Axios.post(`superadmin/document/user`, data).then(response => response.data.data);
export const updateDocument = ( data, id) => Axios.put(`superadminsuperadmin/document/user/${id}`, data);
export const getDocumentList = (data) => Axios.get('superadmin/document/user', { params: data }).then(response => response.data);
export const getDocumentDetail = (id) => Axios.get(`superadmin/document/user/${id}`).then(response => response.data.data);
export const deleteDocument = (id) => Axios.delete(`superadmin/document/user/${id}`);

// Bank Account APIs
export const createBankAccount = (data) => Axios.post(`/bank-account`, data).then(response => response.data.data);
export const updateBankAccount = (data, id) => Axios.put(`/bank-account/${id}`, data).then(response => response.data.data);
export const getBankAccountList = (data) => Axios.get('/bank-account', { params: data }).then(response => response.data);
export const deleteBankAccount = (id) => Axios.delete(`/bank-account/${id}`);